// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1XGpJ","spinning":"Spinner_spinning__3-n4e"};